import {  useMutation } from '@apollo/client'
import React from 'react'
import { PUBLISH_USER } from '../../../../../graphql-client/Mutation'
import { useState } from 'react'
import MakeImg from '../../../../../uploadToS3/MakeImg'
import { uploadImageToS3 } from '../../../../../uploadToS3/UploadImgToS3'
import { ConvertToCloudFrontUrl } from '../../../../../utils/ConvertToCloudFrontUrl'
export default React.memo(function CoverForm(props) {
        const [coverForm, setCoverForm] = useState({ thumbnail:'',  });
        const [croppedImage, setCroppedImage] = useState(null);
        const userId = props.userId
        const [settingUser] = useMutation(PUBLISH_USER,{
          variables:{
            cover: coverForm.thumbnail,
          },
        });
        const handleSubmit = async (e) => {
          e.preventDefault();
          await uploadImageToS3(croppedImage, coverForm, setCoverForm, userId)
          settingUser();
          setCoverForm({ thumbnail: ''})
          setCroppedImage(null)
        };
    return (
      <div className="setting-media-form"> 
        <div className='form-group d-flex flex-column'>
          <MakeImg formListVideo={coverForm} setFormListVideo={setCoverForm}
                    croppedImage={croppedImage} setCroppedImage={setCroppedImage}
          >
          </MakeImg>
          {croppedImage && (
            <button onClick={handleSubmit} className="btn btn-gradient-upload mx-auto mt-2">
              Cập nhật ảnh cover
            </button>
          )}
          <div className='setting-cover-preview mt-3'>
            <img src={ConvertToCloudFrontUrl(props.coverManager)} alt={'ảnh bìa của người dùng ' + props.username} />
          </div>
        </div>
      </div> 
    )
})
